import React, { useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Path from "src/constants/path";
import { useBloc } from "src/state/state";
import UserCubit from "src/state/UserCubit/UserCubit";
import { createAppPath } from "src/lib/createAppPath";
import RedirectWithQueryParams from "../RedirectWithQueryParams/RedirectWithQueryParams";

const PlanRouter = () => {
  const [, userCubit] = useBloc(UserCubit);

  useEffect(() => {
    if (!userCubit.programMemberships) {
      void userCubit.getProfileAttributes();
    }
  }, [userCubit]);

  return (
    <div>
      <Routes>
        {/* REDIRECT FOR UNKNOWN PATHS */}
        <Route
          path="*"
          element={<RedirectWithQueryParams to={createAppPath(Path.myPlan)} />}
        />
      </Routes>
    </div>
  );
};

export default PlanRouter;
